import { useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, ShieldCheck, CheckCircle2 } from "lucide-react";

export default function PortalLogin() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Vul uw e-mailadres in");
    setBusy(true);
    try {
      await api.post("/portal/request", { email: email.trim() });
      setSent(true);
    } catch { toast.error("Er ging iets mis, probeer het later opnieuw"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0F1E3D] flex items-center justify-center px-4 border-b-8 border-[#C9A227]">
      <div className="w-full max-w-md space-y-6">
        <div className="flex items-center gap-3 justify-center">
          <div className="h-11 w-11 rounded-xl bg-white p-1 flex items-center justify-center shadow-sm ring-2 ring-[#C9A227]/70"><img src="/logo.png" alt="" className="h-full w-full object-contain" /></div>
          <div><div className="font-heading font-bold text-white text-lg">Debiteurenportaal</div><div className="text-xs text-[#C9A227] tracking-wide">Praktisch-Debiteurenbeheer</div></div>
        </div>
        {sent ? (
          <Card className="p-8 text-center" data-testid="portal-login-sent">
            <CheckCircle2 className="h-12 w-12 text-[#C9A227] mx-auto mb-3" />
            <h1 className="font-heading text-xl font-bold text-slate-900">Controleer uw e-mail</h1>
            <p className="text-slate-500 mt-2 text-sm">Als dit e-mailadres bij ons bekend is, hebben we een inloglink gestuurd. De link is 30 minuten geldig en kan één keer worden gebruikt.</p>
          </Card>
        ) : (
          <Card className="p-8">
            <h1 className="font-heading text-xl font-bold text-slate-900 mb-1">Inloggen</h1>
            <p className="text-slate-500 text-sm mb-5">Vul uw e-mailadres in. U ontvangt een veilige inloglink — geen wachtwoord nodig.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="flex items-center gap-2"><Mail className="h-4 w-4" /> E-mailadres</Label>
                <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="uw@email.nl" data-testid="portal-email-input" className="mt-1" />
              </div>
              <Button type="submit" className="w-full bg-[#0F1E3D] hover:bg-[#1B2D52] text-white" disabled={busy} data-testid="portal-request-button">
                {busy ? "Bezig..." : "Stuur mij een inloglink"}
              </Button>
            </form>
            <p className="text-xs text-slate-400 flex items-center gap-1 mt-4"><ShieldCheck className="h-3.5 w-3.5" /> Veilige, wachtwoordloze toegang tot uw eigen dossier.</p>
          </Card>
        )}
      </div>
    </div>
  );
}
